import {Component, inject} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators
} from '@angular/forms';
import {noSoloEspacios} from '../../../clientes/pages/clientes-form-component/validations';
import {NgClass} from '@angular/common';
import {AuthLayoutComponent} from '../auth-layout/auth-layout';
import {Router} from '@angular/router';
import {ValidationCodeComponent} from '../validation-code/validation-code';
import {MessageSucces} from '../message-succes/message-succes';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    AuthLayoutComponent,
    ValidationCodeComponent,
    MessageSucces
  ],
  templateUrl: './register.html',
  styleUrl: './register.scss'
})
export class RegisterComponent {
  private formBuilder = inject(FormBuilder);
  private ruter = inject(Router);

  protected submitted= false;
  protected showEmptyFieldsError = false;
  protected showValidateCode = true;
  protected showMessageSucces = true;
  protected messageModal = 'Tu cuenta ha sido creada correctamente';

  onSubmit() {
    this.showEmptyFieldsError = false;
    this.submitted = true;

    if (this.formRegister.invalid) {
      // Verifica si hay campos vacíos
      const camposVacios = Object.keys(this.formRegister.controls).some(key => {
        const control = this.formRegister.get(key);
        return control?.hasError('required') || control?.value === '';
      });
    
      if (camposVacios) {
        this.showEmptyFieldsError = true;
      }
    
      return;
    }

    this.showValidateCode = true;

  }

  onCancel() : void{
    this.ruter.navigate(['/iniciar'])
  }

  formRegister = this.formBuilder.group({
    name:  new FormControl ('',[ Validators.required, noSoloEspacios()]),
    email:  new FormControl('', [Validators.required, Validators.email]),
    password:  new FormControl ('',[ Validators.required, Validators.pattern(/^[A-Z][A-Za-z\d@$!%*?&]{7,}$/)]),
    confirmPassword:  new FormControl ('',[ Validators.required ]),
  },  { validators: this.validatePasswords });

  validatePasswords(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordsNoCoinciden: true };
  }

  get name(){return this.formRegister.get('name');}
  get email(){return this.formRegister.get('email');}
  get password() {return this.formRegister.get('password');}
  get confirmPassword (){return this.formRegister.get('confirmPassword')}
}
